import api from "../index";
import { apiUrl } from "../../utils/constants";

// The web currently uses position results only for {id, name} dropdowns
// (MainLayout, DashboardLayout, EditProfileBio, AddSalonModal,
// BussinessDetail, MemberDetail). Opt into the backend `light=1` path so
// unused columns are dropped. Legacy clients (mobile app) never send this
// param and keep the default response.
export const GetPositions = (params) =>
  api.get(apiUrl.positions, { params: { ...(params || {}), light: 1 } });
